import { Component } from '@angular/core';
import { NavController,NavParams,LoadingController} from 'ionic-angular';
import { WebService } from '../../../providers/service/webservice';
import { MSGDETAIL } from '../../../providers/config/serviceurl';
import { ReceiptPage } from '../receipt/receipt'
import { AppState } from '../../../app/app.global';
@Component({
  selector: 'message-detail-page',
  templateUrl: 'detail.html'
})
export  class MessageDetail{

  msgDetail:any={id:null,title:null,releaseDept:null,releaseDate:null,content:null};
  constructor(public navCtrl: NavController,public navParm :NavParams,private loadCtrl:LoadingController
  	,public global: AppState,private webService:WebService) {
  }
  
  openReceiptPage(){
  	let params = {"msgId":this.msgDetail.id,"msgTitle":this.msgDetail.title,
  	"releaseDept":this.msgDetail.releaseDept,"releaseDate":this.msgDetail.releaseDate,"userId":this.navParm.data.userId};
  	this.navCtrl.push(ReceiptPage,params);
  }

}



// WEBPACK FOOTER //
// ./src/pages/message/detail/detail.ts